// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"397":"3b53517f","437":"3b53517f","472":"3b53517f","554":"3b53517f","818":"3b53517f"}[chunkId] + ".chunk.css";
};